module.exports = __webpack_public_path__ + "static/media/seicon.1f80d880.png";